import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'src/hooks/useAuth'
import CustomLoader from '../common/CustomLoader';

const ProtectedRoute = ({ children,requiredAuthCode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    // return <div>Loading...</div>; // Optionally, show a loading state
    return <CustomLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check authorization code if required
  if (requiredAuthCode && user.auth_cd !== requiredAuthCode) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
